var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBioEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 508.539 508.539",
    height: 512,
    viewBox: "0 0 508.539 508.539",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1523_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1770_",
    d: "m225.436 321.006c0 15.967 12.989 28.956 28.956 28.956s28.956-12.989 28.956-28.956c0-8.765-13.59-28.702-28.956-46.06-15.366 17.356-28.956 37.294-28.956 46.06z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1823_",
    d: "m362.799 268.555c0-24.845-16.796-58.761-49.921-100.806-23.645-30.013-46.935-53.22-47.915-54.193l-10.57-10.498c-.195.254-108.407 102.963-108.407 165.497 0 50.683 34.964 93.347 82.036 105.156-19.302-9.696-32.585-29.673-32.585-52.706 0-13.708 8.241-30.833 25.195-52.353 13.03-16.54 23.451-26.465 33.761-36.72 10.231 10.178 20.412 19.777 33.761 36.72 16.954 21.52 25.195 38.645 25.195 52.353 0 23.032-13.284 43.009-32.585 52.705 47.072-11.808 82.035-54.472 82.035-105.155z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1824_",
    d: "m108.95 235.926-16.808-24.85-19.659 13.297c14.335-87.843 90.74-155.104 182.572-155.104 69.233 0 132.139 38.173 164.167 99.622l26.604-13.866c-67.438-129.385-240.488-155.094-342.799-52.783-34.238 34.238-55.506 77.99-61.336 125.295l-25.215-16.572-16.476 25.07 55.175 36.263z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1834_",
    d: "m508.539 241.576-57.352-36.11-51.619 36.563 17.34 24.481 23.098-16.361c2.287 103.814-81.512 189.12-184.95 189.12-80.57 0-151.331-51.467-176.079-128.069l-28.547 9.223c28.2 87.289 109.752 148.847 204.626 148.847 119.148 0 215.8-96.789 214.985-216.481l22.514 14.175z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBioEnergy);
export default __webpack_public_path__ + "static/media/bio-energy.ec55ab3732f8b4a0ff6cf3c100a9680f.svg";
export { ForwardRef as ReactComponent };